/** A price in the reader's language, e.g. "12,99 €" in Bulgarian or "€12.99" in English. */
export function formatPrice(price: number, currency: string, language: string): string {
   try {
      return new Intl.NumberFormat(language, { style: 'currency', currency: currency || 'EUR' }).format(price);
   } catch {
      return `${price} ${currency}`;
   }
}

/**
 * A count in the reader's language, e.g. "3 412" in Bulgarian or "3,412" in
 * English. Always grouped: Bulgarian otherwise leaves four digits as "3412".
 */
export function formatNumber(value: number, language: string): string {
   return new Intl.NumberFormat(language, { useGrouping: 'always' as unknown as boolean }).format(value);
}

/** A date and time in the reader's language, e.g. "24.10.2026 г., 09:00". */
export function formatDate(millis: number | null | undefined, language: string): string {
   if (!millis) return '';
   return new Intl.DateTimeFormat(language, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(millis));
}

/** The message key for an error a shop callable threw: its `details.code` when it sent one. */
export function errorKey(error: unknown): string {
   const code = (error as { details?: { code?: unknown } })?.details?.code;
   const known = ['invalid-url', 'unreachable', 'blocked', 'no-products', 'too-many-shops', 'feed-needed', 'refresh-too-soon'];
   return typeof code === 'string' && known.includes(code) ? `errors.${code}` : 'errors.general';
}
